import * as Yup from "yup";
import { Button, Divider } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { Whisper, Tooltip, DatePicker } from "rsuite";
import InfoRoundIcon from "@rsuite/icons/InfoRound";

function DoctorAddEduInfo({ eduVars }) {
  const {
    draftEducation,
    setDraftEducation,
    editEducationIndex,
    setEditEducationIndex,
    formik,
    doctorData,
    handleRemoval,
  } = eduVars;

 

 const handleAddEducation = () => {
  const newEducation = {
    _EductionhigherId: 0,
    userclinicid: doctorData?.userclinicid ?? 0,
    useruniqueid: doctorData?.useruniqueid ?? 0,
    doctorid: doctorData?.doctorId ?? 0,
    highestQualification: "",
    university: "",
    fieldofstudy: "",
    certifications: "",
    percentage: "",
    startDate: "",
    endDate: "",
  };

  formik.setFieldValue("Eductioncertificates", [
    ...formik.values.Eductioncertificates,
    newEducation
  ]);
  setEditEducationIndex(formik.values.Eductioncertificates.length);
};

  const handleDraftChange = (e) => {
    const { name, value } = e.target;

    if (name === "skills") {
      setDraftEducation((prev) => {
        
        return { ...prev, [name]: value };
      });
    } else {
      setDraftEducation((prev) => {
       
        return { ...prev, [name]: value };
      });
    }
  };

  return (
    <div className="row">
      <div className="mt-2">
        <div className="d-flex">
          <h5
            className="fw-semibold h5-WOeTzEASAL"
            style={{ color: "rgb(43, 81, 147)", marginTop: "2rem" }}
          >
            Education Info
          </h5>

          <Whisper
            placement="top"
            trigger="hover"
            speaker={<Tooltip>Click to add and save education</Tooltip>}
          >
            <button
              onClick={handleAddEducation}
              className="div-4Y5tjWkFrQ"
              style={{
                marginTop: "2rem",
                height: "2.5rem",
                marginBottom: ".5rem",
                marginLeft: "auto",
                width: "unset",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0 1rem",
                cursor: "pointer",
              }}
              type="button"
            >
              Add Education <InfoRoundIcon />
            </button>
          </Whisper>
        </div>

        <div className="col-12 d-flex flex-wrap">
          {formik.values.Eductioncertificates
            ?.slice(0, 5)
            .map((education, index) => {
              const eduErrors = formik.errors.Eductioncertificates?.[index];
              const eduTouched = formik.touched.Eductioncertificates?.[index];
              const hasError = eduErrors && eduTouched;
              return (
                <button
                  className="btn-kobmSyo3qQ"
                  onClick={() => setEditEducationIndex(index)}
                  key={index}
                  style={
                    education.highestQualification === "" || hasError
                      ? { backgroundColor: "#ff11009e", color: "white" }
                      : {}
                  }
                  type="button"
                >
                  {education.highestQualification === ""
                    ? "Add Qualification"
                    : education.highestQualification}
                </button>
              );
            })}
          {formik.values.Eductioncertificates?.length > 5 && (
            <Popover
              placement="right"
              content={
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {formik.values.Eductioncertificates
                    ?.slice(5, formik.values.Eductioncertificates.length)
                    .map((education, index) => {
                      const eduErrors =
                        formik.errors.Eductioncertificates?.[index];
                      const eduTouched =
                        formik.touched.Eductioncertificates?.[index];
                      const hasError = eduErrors && eduTouched;
                      return (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <button
                            className="btn-kobmSyo3qQ"
                            style={
                              education.highestQualification === "" || hasError
                                ? {
                                    backgroundColor: "#ff11009e",
                                    color: "white",
                                    marginTop: ".4rem",
                                  }
                                : { marginTop: ".4rem" }
                            }
                            onClick={() => setEditEducationIndex(index)}
                            type="button"
                          >
                            {education.highestQualification === ""
                              ? "Add Qualification"
                              : education.highestQualification}
                          </button>
                        </div>
                      );
                    })}
                </div>
              }
              title="Additional Experiences"
              trigger="click"
            >
              <button className="btn-kobmSyo3qQ">
                +{formik.values.Eductioncertificates.length - 5}
              </button>
            </Popover>
          )}
        </div>

        <div className="row">
          <Divider style={{ margin: ".4rem 0" }} />

          {formik.values.Eductioncertificates.length > 0 ? (
            <>
              <div className="col-12 d-flex justify-content-end">
                <Button
                  onClick={() => handleRemoval("education")}
                  style={{ width: "1rem" }}
                  color="danger"
                  disabled={formik.values.Eductioncertificates.length === 1}
                  variant="dashed"
                >
                  <DeleteOutlined />
                </Button>
              </div>
              <div className="col-md-3 col-12">
                <div className="input-block mb-3">
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    University<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter University Name"
                    name={`Eductioncertificates[${editEducationIndex}].university`}
                    value={
                      formik.values.Eductioncertificates[editEducationIndex]
                        ?.university || ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.Eductioncertificates?.[editEducationIndex]
                    ?.university &&
                    formik.errors.Eductioncertificates?.[editEducationIndex]
                      ?.university && (
                      <div style={{ fontSize: "0.8rem", color: "red" }}>
                        {
                          formik.errors.Eductioncertificates[editEducationIndex]
                            .university
                        }
                      </div>
                    )}
                </div>
              </div>

              <div className="col-md-3 col-12">
                <div className="input-block mb-3">
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    Qualification<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Position"
                    name={`Eductioncertificates[${editEducationIndex}].highestQualification`}
                    value={
                      formik.values.Eductioncertificates[editEducationIndex]
                        ?.highestQualification
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.Eductioncertificates?.[editEducationIndex]
                    ?.highestQualification &&
                    formik.errors.Eductioncertificates?.[editEducationIndex]
                      ?.highestQualification && (
                      <div style={{ fontSize: "0.8rem", color: "red" }}>
                        {
                          formik.errors.Eductioncertificates[editEducationIndex]
                            .highestQualification
                        }
                      </div>
                    )}
                </div>
              </div>

              <div className="col-md-3 col-12">
                <div className="input-block mb-3">
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    Field of Study<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Field of Study"
                    name={`Eductioncertificates[${editEducationIndex}].fieldofstudy`}
                    value={
                      formik.values.Eductioncertificates[editEducationIndex]
                        ?.fieldofstudy
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.Eductioncertificates?.[editEducationIndex]
                    ?.fieldofstudy &&
                    formik.errors.Eductioncertificates?.[editEducationIndex]
                      ?.fieldofstudy && (
                      <div style={{ fontSize: "0.8rem", color: "red" }}>
                        {
                          formik.errors.Eductioncertificates[editEducationIndex]
                            .fieldofstudy
                        }
                      </div>
                    )}
                </div>
              </div>

              <div className="col-md-3 col-12">
                <div className="input-block mb-3">
                  <label className="col-form-label lbl-VLJQLgvYMk">
                    Percentage
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Percentage"
                    name={`Eductioncertificates[${editEducationIndex}].percentage`}
                    value={
                      formik.values.Eductioncertificates[editEducationIndex]
                        ?.percentage
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>

              <div className="row g-3 align-items-start">
  {/* Start Date */}
  <div className="col-md-3 col-12">
    <label className="col-form-label lbl-VLJQLgvYMk">
      Start Date
    </label>
    <DatePicker
      block
      oneTap
      format="dd-MMM-yyyy"
      placeholder="dd-mmm-yyyy"
      name={`Eductioncertificates[${editEducationIndex}].startDate`}
      value={
        formik.values.Eductioncertificates[editEducationIndex]?.startDate
          ? new Date(
              formik.values.Eductioncertificates[editEducationIndex]?.startDate
            )
          : null
      }
      onChange={(date) =>
        formik.setFieldValue(
          `Eductioncertificates[${editEducationIndex}].startDate`,
          date
        )
      }
      onBlur={() =>
        formik.setFieldTouched(
          `Eductioncertificates[${editEducationIndex}].startDate`,
          true
        )
      }
    />
  </div>

  {/* End Date */}
  <div className="col-md-3 col-12">
    <label className="col-form-label lbl-VLJQLgvYMk">
      Last Date<span className="text-danger">*</span>
    </label>
    <DatePicker
      block
      oneTap 
      format="dd-MMM-yyyy"
      placeholder="dd-mmm-yyyy"
      name={`Eductioncertificates[${editEducationIndex}].endDate`}
      value={
        formik.values.Eductioncertificates[editEducationIndex]?.endDate
          ? new Date(
              formik.values.Eductioncertificates[editEducationIndex]?.endDate
            )
          : null
      }
      onChange={(date) =>
        formik.setFieldValue(
          `Eductioncertificates[${editEducationIndex}].endDate`,
          date
        )
      }
      onBlur={() =>
        formik.setFieldTouched(
          `Eductioncertificates[${editEducationIndex}].endDate`,
          true
        )
      }
    />
    {formik.touched.Eductioncertificates?.[editEducationIndex]?.endDate &&
      formik.errors.Eductioncertificates?.[editEducationIndex]?.endDate && (
        <div className="text-danger small">
          {
            formik.errors.Eductioncertificates[editEducationIndex]
              .endDate
          }
        </div>
      )}
  </div>

  {/* Certifications */}
  <div className="col-md-6 col-12">
    <label className="col-form-label lbl-VLJQLgvYMk">Certifications</label>
    <textarea
      className="form-control"
      placeholder="Describe your Experience..."
      style={{
        height: "110px",
        fontSize: "0.9rem",
        padding: "0.8rem",
        lineHeight: "1.6",
        color: "#424242",
        letterSpacing: "0.5px",
      }}
      name={`Eductioncertificates[${editEducationIndex}].certifications`}
      value={
        formik.values.Eductioncertificates[editEducationIndex]?.certifications
      }
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
    ></textarea>
  </div>
</div>

            </>
          ) :""}
        </div>
      </div>
    </div>
  );
}

export default DoctorAddEduInfo;
